var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8917 23.659C18.7484 24.7674 17.5 24.5924 16.2984 24.0674C15.0267 23.5307 13.86 23.5074 12.5184 24.0674C10.8384 24.7907 9.9517 24.5807 8.94836 23.659C3.25503 17.7907 4.09503 8.85402 10.5584 8.52736C12.1334 8.60902 13.23 9.39069 14.1517 9.46069C15.5284 9.18069 16.8467 8.37569 18.3167 8.48069C20.0784 8.62069 21.4084 9.32069 22.2834 10.5807C18.6434 12.7624 19.5067 17.5574 22.8434 18.899C22.1784 20.649 21.315 22.3874 19.88 23.6707L19.8917 23.659ZM14.035 8.45736C13.86 5.85569 15.9717 3.70902 18.3984 3.49902C18.7367 6.50902 15.6684 8.74902 14.035 8.45736Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/apple_icon.74482b6618925b30fc0af9b61858c925.svg";
export { ForwardRef as ReactComponent };